import {
  createStore as createReduxStore,
  applyMiddleware,
  combineReducers,
  compose,
} from "redux";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";
import { reducer as formReducer } from 'redux-form';

export const createStore = (config: AppConfig) => {
  const composeWithDevTools = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

  const rootSaga = function* sagas() {
    yield all([]);
  };

  const rootReducer = combineReducers<AppState>({
    form: formReducer,
  });

  const sagaMiddleware = createSagaMiddleware({
    context: { config }
  });

  const middlewares = [sagaMiddleware];

  const store = createReduxStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(...middlewares))
  );

  sagaMiddleware.run(rootSaga);

  return store;
};
